/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'video': {
    width: 16,
    height: 16,
    viewBox: '0 0 35 33',
    data: '<g _fill="#000" fill-rule="nonzero"><path pid="0" d="M6 2h2v29.894H6zM27 2h2v29.894h-2z"/><path pid="1" d="M2 9V7h4.904v2zM29 9V7h4.904v2zM2 15v-2h4.904v2zM29 15v-2h4.904v2zM2 21v-2h4.904v2zM7 18v-2h20.506v2zM29 21v-2h4.904v2zM2 27v-2h4.904v2zM29 27v-2h4.904v2z"/><path pid="2" d="M2 2v29h31V2H2zM1 0h33a1 1 0 011 1v31a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1z"/></g>'
  }
})
